import { sagaCreator } from '@adrias-online/steiner';

import helper from 'helpers/steinerHelper';
import { actions, actionTypes } from '../actions/portaliIndicatoriHotels';
import { selectors, DEFAULT_STATE } from '../reducers/portaliIndicatoriHotels';
import api from '../apis/portaliIndicatoriHotels';

const sagas = helper.createSagas(
    'portaliIndicatoriHotels',
    actionTypes,
    actions,
    api,
    selectors,
    DEFAULT_STATE
);

const defaultSagas = sagaCreator.bootSagas(sagas, actionTypes);

export default [...defaultSagas];
